import { render, staticRenderFns } from "./products-business.edit.demo.vue?vue&type=template&id=08dbb30e&"
import script from "./products-business.edit.demo.vue?vue&type=script&lang=js&"
export * from "./products-business.edit.demo.vue?vue&type=script&lang=js&"
import style0 from "./products-business.edit.demo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "products-business.edit.demo.vue"
export default component.exports